import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Sidebar_Progress from "../../../layouts/Admin_Sidebar_Progress.component";
import LoginHeaderOperational from '../../LoginHeaderOperational';
import swal from "sweetalert";
import { API_URL } from "../../../../constant/API_Settings";
import { fetchPlatformSuperAdminProfile } from '../../../../utils/platformAuth';
import Loader from '../../Employee/Loader.component';
import '../admin-dashboard.css';
import './AdminPumpsDetails.css';
import AdminPumpUsageDashboard from '../AdminPumpUsageDashboard';
import '../AdminPumpUsageDashboard.css';

const MIN_DELETE_REASON_LENGTH = 10;

const getDefaultMonthRange = () => {
    const now = new Date();
    const from = new Date(now.getFullYear(), now.getMonth(), 1);
    const to = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const toInput = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };
    return { from_date: toInput(from), to_date: toInput(to) };
};

const AdminPumpsDetailscomponent = (props) => {
    const history = useHistory();
    const [pumpsData, setPumpsData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [pages, setPages] = useState({
        current_page: 1,
        total_pages: 1,
    });
    const [loading, setLoading] = useState(false);
    const abortControllerRef = useRef(null);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [deleteReason, setDeleteReason] = useState('');
    const [exportLoading, setExportLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [downloadingBackupPumpId, setDownloadingBackupPumpId] = useState(null);

    const [showGasReportModal, setShowGasReportModal] = useState(false);
    const [gasReportTarget, setGasReportTarget] = useState(null);
    const [gasReportRange, setGasReportRange] = useState(getDefaultMonthRange());
    const [gasReportLoading, setGasReportLoading] = useState(false);

    const [showPlBlModal, setShowPlBlModal] = useState(false);
    const [plBlTarget, setPlBlTarget] = useState(null);
    const [plBlRange, setPlBlRange] = useState(getDefaultMonthRange());
    const [plBlLoading, setPlBlLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('pumps'); // pumps | usage | analysis
    const [sortBy, setSortBy] = useState('last_active');

    const parseApiError = async (response) => {
        try {
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json')) {
                const data = await response.json();
                return data.msg || data.message || 'Request failed.';
            }

            const buffer = await response.arrayBuffer();
            const text = new TextDecoder().decode(buffer.slice(0, 4000)).trim();
            if (!text) {
                return `Request failed (${response.status}).`;
            }

            try {
                const data = JSON.parse(text);
                return data.msg || data.message || text;
            } catch (e) {
                return text.length > 300 ? text.slice(0, 300) + '…' : text;
            }
        } catch (e) {
            return `Request failed (${response.status}).`;
        }
    };

    const pumpactivity = useCallback((query = "", page = 1, sort = "last_active") => {
        setLoading(true);

        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        const newAbortController = new AbortController();
        abortControllerRef.current = newAbortController;

        const requestOptions = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN"),
                "Accept": "application/json"
            },
            body: JSON.stringify({ search_keyword: query, page: page, sort }),
            signal: newAbortController.signal
        };

        fetch(`${API_URL}/activity`, requestOptions)
            .then(response => response.json())
            .then(responseData => {
                setLoading(false);
                if (responseData.status) {
                    setPumpsData(responseData.data.data || []);
                    setPages({
                        current_page: responseData.data.current_page || 1,
                        total_pages: responseData.data.last_page || 1,
                    });
                    setCurrentPage(responseData.data.current_page || 1);
                } else {
                    swal("Error", "Failed to fetch pump activity data", "error");
                }
            })
            .catch(e => {
                if (e.name === 'AbortError') {
                    console.log("Fetch aborted");
                } else {
                    setLoading(false);
                    console.error("Error fetching pump activity:", e);
                }
            });
    }, []);

    useEffect(() => {
        fetchPlatformSuperAdminProfile(API_URL, localStorage.getItem('AUTH_TOKEN'))
            .then((profile) => {
                if (profile) {
                    pumpactivity('', 1);
                } else {
                    history.goBack();
                }
            })
            .catch(() => history.goBack());
    }, [history, pumpactivity]);

    const handleSearch = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        pumpactivity(query, 1, sortBy);
    };

    const handleSortChange = (e) => {
        const sort = e.target.value;
        setSortBy(sort);
        setCurrentPage(1);
        pumpactivity(searchQuery, 1, sort);
    };

    const handlePagination = (number) => {
        setCurrentPage(number);
        pumpactivity(searchQuery, number, sortBy);
    };

    const paginationItems = () => {
        const items = [];
        const totalPages = pages.total_pages;

        let start = Math.floor((currentPage - 1) / 10) * 10 + 1;
        let end = Math.min(start + 9, totalPages);

        for (let i = start; i <= end; i++) {
            items.push(
                <button
                    key={i}
                    type="button"
                    className={`btn btn-sm ${i === currentPage ? 'btn-primary' : 'btn-outline-secondary'}`}
                    onClick={() => handlePagination(i)}
                >
                    {i}
                </button>
            );
        }

        return items;
    };

    const formatTime = (time) => {
        if (!time) return "-";
        const [hours, minutes] = time.split(":");
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12;
        return `${formattedHours}:${minutes} ${ampm}`;
    };

    const togglePumpStatus = (pumpId, currentStatus) => {
        const newStatus = currentStatus === 1 ? 2 : 1;
        const action = currentStatus === 1 ? "deactivate" : "activate";
        const confirmationMessage = `Do you want to ${action} this pump?`;

        swal({
            title: confirmationMessage,
            icon: "warning",
            buttons: ["Cancel", "Yes"],
            dangerMode: true,
        }).then((willChange) => {
            if (willChange) {
                setLoading(true);
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN"),
                    },
                    body: JSON.stringify({ id: pumpId, status: newStatus }),
                };

                fetch(`${API_URL}/pumpdeactive`, requestOptions)
                    .then(response => response.json())
                    .then(responseData => {
                        setLoading(false);
                        if (responseData.status) {
                            setPumpsData(pumpsData.map(pump => 
                                pump.id === pumpId ? { ...pump, pump_status: newStatus } : pump
                            ));
                            swal("Success", responseData.msg, "success");
                            pumpactivity(searchQuery, pages.currentPage);
                        } else {
                            swal("Error", responseData.msg || "Failed to update pump status.", "error");
                        }
                    })
                    .catch((e) => {
                        setLoading(false);
                        console.error("Error updating pump status:", e);
                    });
            }
        });
    };

    const openGasReportModal = (pump) => {
        setGasReportTarget(pump);
        setGasReportRange(getDefaultMonthRange());
        setShowGasReportModal(true);
    };

    const closeGasReportModal = () => {
        if (gasReportLoading) {
            return;
        }
        setShowGasReportModal(false);
        setGasReportTarget(null);
    };

    const downloadGasReport = () => {
        if (!gasReportTarget) {
            return;
        }

        if (!gasReportRange.from_date || !gasReportRange.to_date) {
            swal('Date required', 'Please select both from and to dates.', 'warning');
            return;
        }

        if (gasReportRange.from_date > gasReportRange.to_date) {
            swal('Invalid range', 'From date cannot be after to date.', 'warning');
            return;
        }

        setGasReportLoading(true);

        fetch(`${API_URL}/pump-gas-report-export`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream, application/json',
            },
            body: JSON.stringify({
                pump_id: gasReportTarget.pump_id,
                from_date: gasReportRange.from_date,
                to_date: gasReportRange.to_date,
            }),
        })
            .then(async (response) => {
                if (!response.ok) {
                    throw new Error(await parseApiError(response));
                }

                const blob = await response.blob();
                if (!blob || blob.size < 100) {
                    throw new Error('Gas report file was empty. Please try again.');
                }

                const disposition = response.headers.get('content-disposition') || '';
                const match = disposition.match(/filename="?([^";]+)"?/i);
                const filename = match
                    ? match[1].trim()
                    : `gas_cylinder_sales_report_${gasReportTarget.pump_id}.xlsx`;

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(link.href);

                swal('Downloaded', 'Gas Cylinder Sales Report downloaded successfully.', 'success');
                closeGasReportModal();
            })
            .catch((error) => {
                swal('Download failed', error.message || 'Unable to download gas report.', 'error');
            })
            .finally(() => setGasReportLoading(false));
    };

    const openPlBlModal = (pump) => {
        setPlBlTarget(pump);
        setPlBlRange(getDefaultMonthRange());
        setShowPlBlModal(true);
    };

    const closePlBlModal = () => {
        if (plBlLoading) {
            return;
        }
        setShowPlBlModal(false);
        setPlBlTarget(null);
    };

    const downloadPlBlReport = () => {
        if (!plBlTarget) {
            return;
        }

        if (!plBlRange.from_date || !plBlRange.to_date) {
            swal('Date required', 'Please select both from and to dates.', 'warning');
            return;
        }

        if (plBlRange.from_date > plBlRange.to_date) {
            swal('Invalid range', 'From date cannot be after to date.', 'warning');
            return;
        }

        setPlBlLoading(true);

        fetch(`${API_URL}/pump-pl-bl-export`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream, application/json',
            },
            body: JSON.stringify({
                pump_id: plBlTarget.pump_id,
                from_date: plBlRange.from_date,
                to_date: plBlRange.to_date,
            }),
        })
            .then(async (response) => {
                if (!response.ok) {
                    throw new Error(await parseApiError(response));
                }

                const blob = await response.blob();
                if (!blob || blob.size < 100) {
                    throw new Error('P&L / Balance Sheet file was empty. Please try again.');
                }

                const disposition = response.headers.get('content-disposition') || '';
                const match = disposition.match(/filename="?([^";]+)"?/i);
                const filename = match
                    ? match[1].trim()
                    : `pl_bl_${plBlTarget.pump_id}.xlsx`;

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(link.href);

                swal('Downloaded', 'Trade P&L and Balance Sheet downloaded successfully.', 'success');
                closePlBlModal();
            })
            .catch((error) => {
                swal('Download failed', error.message || 'Unable to download P&L / Balance Sheet.', 'error');
            })
            .finally(() => setPlBlLoading(false));
    };

    const openDeleteModal = (pump) => {
        setDeleteTarget(pump);
        setDeleteReason('');
        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        if (exportLoading || deleteLoading) {
            return;
        }
        setShowDeleteModal(false);
        setDeleteTarget(null);
        setDeleteReason('');
    };

    const isReasonValid = deleteReason.trim().length >= MIN_DELETE_REASON_LENGTH;

    const exportPumpBackupFile = (pumpId, reason) => {
        return fetch(`${API_URL}/pump-delete-export`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream, application/json',
            },
            body: JSON.stringify({
                id: pumpId,
                reason: reason.trim(),
            }),
        })
            .then(async (response) => {
                if (!response.ok) {
                    throw new Error(await parseApiError(response));
                }

                const blob = await response.blob();
                if (!blob || blob.size < 100) {
                    throw new Error('Export file was empty. Please try again.');
                }

                const disposition = response.headers.get('content-disposition') || '';
                const match = disposition.match(/filename="?([^";]+)"?/i);
                const filename = match ? match[1].trim() : `pump_backup_${pumpId}.xlsx`;

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(link.href);
            });
    };

    const downloadPumpData = (pump) => {
        const pumpId = pump.pump_id;
        const reason = `Manual backup download from admin pumps list for pump #${pumpId}.`;

        setDownloadingBackupPumpId(pumpId);

        exportPumpBackupFile(pumpId, reason)
            .then(() => {
                swal('Downloaded', 'Pump data Excel backup downloaded successfully.', 'success');
            })
            .catch((error) => {
                swal('Download failed', error.message || 'Unable to download pump backup.', 'error');
            })
            .finally(() => setDownloadingBackupPumpId(null));
    };

    const downloadPumpBackup = () => {
        if (!deleteTarget || !isReasonValid) {
            swal('Reason required', `Enter at least ${MIN_DELETE_REASON_LENGTH} characters explaining why this pump is being deleted.`, 'warning');
            return;
        }

        setExportLoading(true);

        exportPumpBackupFile(deleteTarget.pump_id, deleteReason.trim())
            .then(() => {
                swal('Backup ready', 'Excel backup downloaded successfully.', 'success');
            })
            .catch((error) => {
                swal('Export failed', error.message || 'Unable to download pump backup.', 'error');
            })
            .finally(() => setExportLoading(false));
    };

    const confirmPermanentDelete = () => {
        if (!deleteTarget || !isReasonValid) {
            swal('Reason required', `Enter at least ${MIN_DELETE_REASON_LENGTH} characters explaining why this pump is being deleted.`, 'warning');
            return;
        }

        swal({
            title: 'Final confirmation',
            text: `Permanently delete "${deleteTarget.pump_name}" and all related data? This cannot be undone. Downloading the Excel backup first is recommended.`,
            icon: 'warning',
            buttons: ['Cancel', 'Yes, delete permanently'],
            dangerMode: true,
        }).then((confirmed) => {
            if (!confirmed) {
                return;
            }

            setDeleteLoading(true);

            fetch(`${API_URL}/pumpdelete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                    // IMPORTANT: without an explicit Accept header, Laravel's
                    // request->expectsJson() check can fail for an uncaught server
                    // error and the framework renders an HTML error page instead of
                    // JSON. That HTML page is what produced the
                    // "Unexpected token '<'" crash reported for certain pumps
                    // (typically ones with a large amount of related data that made
                    // the delete slow). Sending Accept: application/json ensures the
                    // backend always replies with JSON, even on failure.
                    Accept: 'application/json',
                },
                body: JSON.stringify({
                    id: deleteTarget.pump_id,
                    reason: deleteReason.trim(),
                }),
            })
                .then(async (response) => {
                    if (!response.ok) {
                        // Use the same defensive parser the other handlers in this
                        // component use: it safely falls back to raw text if the
                        // response body is not valid JSON (e.g. an HTML error page),
                        // instead of letting response.json() throw a confusing
                        // "Unexpected token '<'" parse error.
                        throw new Error(await parseApiError(response));
                    }

                    const data = await response.json();
                    if (!data.status) {
                        throw new Error(data.msg || 'Failed to delete pump.');
                    }

                    return data;
                })
                .then((data) => {
                    swal('Deleted', data.msg, 'success');
                    closeDeleteModal();
                    pumpactivity(searchQuery, pages.currentPage);
                })
                .catch((error) => {
                    swal('Delete failed', error.message || 'An unexpected error occurred.', 'error');
                })
                .finally(() => setDeleteLoading(false));
        });
    };

    return (
        <div className="main-container page-wrap admin-platform admin-pumps-details">
            <div className="d-md-flex">
                <Sidebar_Progress props={props} progress={23} />
                <div className="content-area">
                    <LoginHeaderOperational props={props} page_title="All Pumps" />
                    <div className="container pb-3 mt-3">
                        <div className="admin-pumps-details__nav">
                            <Link to="/admin_dashboard" className="small">← Control Center</Link>
                            <span className="text-muted mx-2">·</span>
                            <Link to="/admin-analytics" className="small">Platform Analytics</Link>
                        </div>

                        <div className="admin-pumps-details__tabs" role="tablist">
                            <button
                                type="button"
                                className={`admin-pumps-details__tab ${activeTab === 'pumps' ? 'is-active' : ''}`}
                                onClick={() => setActiveTab('pumps')}
                            >
                                All pumps
                            </button>
                            <button
                                type="button"
                                className={`admin-pumps-details__tab ${activeTab === 'usage' ? 'is-active' : ''}`}
                                onClick={() => setActiveTab('usage')}
                            >
                                Usage dashboard
                            </button>
                            <button
                                type="button"
                                className={`admin-pumps-details__tab ${activeTab === 'analysis' ? 'is-active' : ''}`}
                                onClick={() => setActiveTab('analysis')}
                            >
                                Usage analysis
                            </button>
                        </div>

                        {(activeTab === 'usage' || activeTab === 'analysis') && (
                            <div className="mt-3">
                                <AdminPumpUsageDashboard activeTab={activeTab} />
                            </div>
                        )}

                        {activeTab === 'pumps' && (
                        <div className="admin-panel mt-3">
                            <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 mb-3">
                                <div>
                                    <h5 className="mb-1">All pumps</h5>
                                    <p className="text-muted small mb-0">
                                        Activity, status, and management for every registered pump.
                                    </p>
                                </div>
                                <div className="admin-pumps-details__toolbar">
                                    <label className="admin-pumps-details__sort">
                                        <span>Sort by</span>
                                        <select
                                            className="form-select form-select-sm"
                                            value={sortBy}
                                            onChange={handleSortChange}
                                            aria-label="Sort pumps"
                                        >
                                            <option value="last_active">Last active</option>
                                            <option value="name">Pump name</option>
                                        </select>
                                    </label>
                                    <div className="admin-pumps-details__search">
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Search by pump ID, name, email, or phone..."
                                            value={searchQuery}
                                            onChange={handleSearch}
                                        />
                                    </div>
                                </div>
                            </div>

                            {loading ? (
                                <div className="d-flex justify-content-center py-5">
                                    <Loader />
                                </div>
                            ) : pumpsData.length === 0 ? (
                                <div className="admin-dash-empty">
                                    <p className="mb-1"><strong>No pumps found</strong></p>
                                    <p className="text-muted small mb-0">
                                        {searchQuery ? 'Try a different search term.' : 'No pump activity recorded yet.'}
                                    </p>
                                </div>
                            ) : (
                                <>
                                    <div className="table-responsive">
                                        <table className="table table-hover admin-pump-table admin-pumps-details__table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Pump ID</th>
                                                    <th>Pump</th>
                                                    <th>Last active</th>
                                                    <th>Contact</th>
                                                    <th>Address</th>
                                                    <th className="text-end">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pumpsData.map((pump) => (
                                                    <tr key={pump.pump_id}>
                                                        <td className="admin-pumps-details__pump-id">{pump.pump_id ?? '—'}</td>
                                                        <td>
                                                            <div className="admin-dash-pump-name">{pump.pump_name || '—'}</div>
                                                            <span className={`admin-badge ${pump.pump_status === 1 ? 'active' : 'inactive'}`}>
                                                                {pump.pump_status === 1 ? 'Active' : 'Inactive'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <div>{pump.active_date || '—'}</div>
                                                            <div className="admin-dash-pump-meta">
                                                                {pump.user_name || '—'}
                                                                {pump.active_time ? ` · ${formatTime(pump.active_time)}` : ''}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>{pump.pump_email || '—'}</div>
                                                            <div className="admin-dash-pump-meta">{pump.pump_phone || '—'}</div>
                                                        </td>
                                                        <td className="admin-pumps-details__address" title={pump.pump_address || ''}>
                                                            {pump.pump_address || '—'}
                                                        </td>
                                                        <td className="text-end">
                                                            <div className="admin-pumps-details__actions">
                                                                <Link
                                                                    to={`/admin-pump/${pump.pump_id}`}
                                                                    className="btn btn-sm btn-primary"
                                                                >
                                                                    Open
                                                                </Link>
                                                                <button
                                                                    type="button"
                                                                    className={`btn btn-sm ${pump.pump_status === 1 ? 'btn-outline-success' : 'btn-outline-secondary'}`}
                                                                    onClick={() => togglePumpStatus(pump.pump_id, pump.pump_status)}
                                                                >
                                                                    {pump.pump_status === 1 ? 'Deactivate' : 'Activate'}
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-primary"
                                                                    onClick={() => openGasReportModal(pump)}
                                                                >
                                                                    Gas report
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-primary"
                                                                    onClick={() => openPlBlModal(pump)}
                                                                >
                                                                    P&L & BS
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-success"
                                                                    onClick={() => downloadPumpData(pump)}
                                                                    disabled={downloadingBackupPumpId === pump.pump_id}
                                                                >
                                                                    {downloadingBackupPumpId === pump.pump_id
                                                                        ? 'Downloading...'
                                                                        : 'Download data'}
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    onClick={() => openDeleteModal(pump)}
                                                                >
                                                                    Delete
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    {pages.total_pages > 1 && (
                                        <div className="admin-dash-pagination mt-3">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-secondary"
                                                disabled={currentPage === 1}
                                                onClick={() => handlePagination(currentPage - 1)}
                                            >
                                                Previous
                                            </button>
                                            {paginationItems()}
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-secondary"
                                                disabled={currentPage === pages.total_pages}
                                                onClick={() => handlePagination(currentPage + 1)}
                                            >
                                                Next
                                            </button>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                        )}
                    </div>
                </div>
            </div>

            {showGasReportModal && gasReportTarget && (
                <>
                    <div className="pump-delete-modal-backdrop" onClick={closeGasReportModal} />
                    <div className="pump-delete-modal" role="dialog" aria-modal="true">
                        <div className="d-flex justify-content-between align-items-start mb-3">
                            <div>
                                <h5 className="mb-1">Gas Cylinder Sales Report</h5>
                                <div className="text-muted small">{gasReportTarget.pump_name}</div>
                            </div>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={closeGasReportModal}
                                disabled={gasReportLoading}
                            />
                        </div>

                        <div className="row g-2 mb-3">
                            <div className="col-6">
                                <label className="form-label small">From date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={gasReportRange.from_date}
                                    onChange={(e) => setGasReportRange({
                                        ...gasReportRange,
                                        from_date: e.target.value,
                                    })}
                                    disabled={gasReportLoading}
                                />
                            </div>
                            <div className="col-6">
                                <label className="form-label small">To date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={gasReportRange.to_date}
                                    onChange={(e) => setGasReportRange({
                                        ...gasReportRange,
                                        to_date: e.target.value,
                                    })}
                                    disabled={gasReportLoading}
                                />
                            </div>
                        </div>

                        <p className="step-hint mb-3">
                            Downloads an Excel report with Date, Product, Sales Type, MRP, purchase price, GST, return GST, and profit totals.
                        </p>

                        <div className="d-flex justify-content-end gap-2">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={closeGasReportModal}
                                disabled={gasReportLoading}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={downloadGasReport}
                                disabled={gasReportLoading}
                            >
                                {gasReportLoading ? 'Preparing report...' : 'Download Excel'}
                            </button>
                        </div>
                    </div>
                </>
            )}

            {showPlBlModal && plBlTarget && (
                <>
                    <div className="pump-delete-modal-backdrop" onClick={closePlBlModal} />
                    <div className="pump-delete-modal" role="dialog" aria-modal="true">
                        <div className="d-flex justify-content-between align-items-start mb-3">
                            <div>
                                <h5 className="mb-1">Trade P&L &amp; Balance Sheet</h5>
                                <div className="text-muted small">{plBlTarget.pump_name}</div>
                            </div>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={closePlBlModal}
                                disabled={plBlLoading}
                            />
                        </div>

                        <div className="row g-2 mb-3">
                            <div className="col-6">
                                <label className="form-label small">P&amp;L from date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={plBlRange.from_date}
                                    onChange={(e) => setPlBlRange({
                                        ...plBlRange,
                                        from_date: e.target.value,
                                    })}
                                    disabled={plBlLoading}
                                />
                            </div>
                            <div className="col-6">
                                <label className="form-label small">P&amp;L to date / BS as of</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={plBlRange.to_date}
                                    onChange={(e) => setPlBlRange({
                                        ...plBlRange,
                                        to_date: e.target.value,
                                    })}
                                    disabled={plBlLoading}
                                />
                            </div>
                        </div>

                        <p className="step-hint mb-3">
                            Downloads an Excel workbook with structured Trade Profit &amp; Loss (income, COGS,
                            gross profit, salaries, admin expenses, net profit) and Balance Sheet (assets,
                            liabilities, owners&apos; equity) for the selected period.
                        </p>

                        <div className="d-flex justify-content-end gap-2">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={closePlBlModal}
                                disabled={plBlLoading}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={downloadPlBlReport}
                                disabled={plBlLoading}
                            >
                                {plBlLoading ? 'Preparing report...' : 'Download Excel'}
                            </button>
                        </div>
                    </div>
                </>
            )}

            {showDeleteModal && deleteTarget && (
                <>
                    <div className="pump-delete-modal-backdrop" onClick={closeDeleteModal} />
                    <div className="pump-delete-modal" role="dialog" aria-modal="true">
                        <div className="d-flex justify-content-between align-items-start mb-3">
                            <div>
                                <h5 className="mb-1">Delete pump permanently</h5>
                                <div className="text-muted small">{deleteTarget.pump_name}</div>
                            </div>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={closeDeleteModal}
                                disabled={exportLoading || deleteLoading}
                            />
                        </div>

                        <div className="warning-box mb-3">
                            This removes all pump data: accounting, fuel and non-fuel sales, gas cylinders,
                            employees, customers, subscriptions, support tickets, and audit logs.
                        </div>

                        <div className="mb-3">
                            <label className="form-label small fw-semibold">Reason for deletion</label>
                            <textarea
                                className="form-control"
                                rows={4}
                                value={deleteReason}
                                onChange={(e) => setDeleteReason(e.target.value)}
                                placeholder="Explain why this pump is being removed (minimum 10 characters)"
                                disabled={exportLoading || deleteLoading}
                            />
                            <div className="form-text">
                                {isReasonValid
                                    ? 'Reason recorded. You can download a backup or delete directly.'
                                    : `Enter at least ${MIN_DELETE_REASON_LENGTH} characters.`}
                            </div>
                        </div>

                        <p className="step-hint mb-2">
                            Optional: download a full Excel backup before deleting. Includes Balance Sheet
                            and Trade P&amp;L matching the Reports section, plus a formula summary sheet
                            linked to data tabs. Retail fuel sales are in &quot;Fuel Sales (Nozzles)&quot;.
                        </p>
                        <button
                            type="button"
                            className="btn btn-success w-100 mb-3"
                            onClick={downloadPumpBackup}
                            disabled={!isReasonValid || exportLoading || deleteLoading}
                        >
                            {exportLoading ? 'Preparing Excel backup...' : 'Download Excel backup'}
                        </button>

                        <div className="d-flex justify-content-end gap-2">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={closeDeleteModal}
                                disabled={exportLoading || deleteLoading}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={confirmPermanentDelete}
                                disabled={!isReasonValid || exportLoading || deleteLoading}
                            >
                                {deleteLoading ? 'Deleting...' : 'Delete permanently'}
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default AdminPumpsDetailscomponent;
